<template>
  <div>
    <div>
      <el-form
        ref="trainingPriceDetailForm"
        :model="dataModel"
        :rules="rules"
        label-width="100px"
        class="cs-el-input-container-small"
      >
        <div class="main-price">
          <el-row>
            <el-col :span="6">
              <el-form-item
                prop="Name"
                label-width="10px"
              >
                <el-input
                  class="cs-trainingprice-name input-width"
                  :disabled="readonly"
                  v-model="dataModel.Name"
                  required
                  :placeholder="`请输入${mainCourseName}名称`"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col
                :span="3"
                v-if="courseType === GLOBAL.courseType.newStudentGuide"
                class="course-checkbox"
              >
                <el-form-item
                  label=""
                  label-width="10px"
                >
                  <el-checkbox
                    :disabled="readonly"
                    v-model="dataModel.IsHourPrice"
                    class="input-width"
                  >是否小时价
                  </el-checkbox>
                </el-form-item>
              </el-col>
            <el-col :span="colWidth">
              <el-form-item label="课程价：">
                <el-input
                  :disabled="readonly"
                  v-model="dataModel.CoursePrice"
                  placeholder="请输入价格"
                  class="input-width"
                >
                  <template slot="append">$</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col v-if="!dataModel.IsHourPrice" :span="colWidth">
              <el-form-item label="退换价：">
                <el-input
                  :disabled="readonly"
                  v-model="dataModel.RefundPrice"
                  placeholder="请输入价格"
                  class="input-width"
                >
                  <template slot="append">$</template>
                </el-input>
              </el-form-item>
            </el-col>

            <el-col
              :span="colWidth"
              v-if="![GLOBAL.courseType.english, GLOBAL.courseType.newStudentGuide].contains(courseType)"
              class="course-checkbox"
            >
              <el-form-item
                label=""
                label-width="10px"
              >
                <el-checkbox
                  :disabled="readonly"
                  v-model="dataModel.IsFreeVideo"
                  class="input-width"
                >视频免费
                </el-checkbox>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-button
                v-if="!readonly && [GLOBAL.courseType.english, GLOBAL.courseType.newStudentGuide].contains(courseType)"
                size="medium"
                type="text"
                icon="el-icon-delete"
                class="delete-button"
                @click="deleteCourse(dataModel)"
              >删除</el-button>
            </el-col>
          </el-row>
          <el-row v-if="![GLOBAL.courseType.english, GLOBAL.courseType.newStudentGuide].contains(courseType)">
            <el-col
              :span="colWidth"
            >
              <el-form-item label="每周课数：">
                <el-input-number
                  size="small"
                  :min="1"
                  :max="99"
                  :disabled="readonly"
                  v-model="dataModel.WeekCount"
                  placeholder="请输入课数"
                  class="input-width"
                >
                </el-input-number>
              </el-form-item>
            </el-col>
            <el-col
              :span="colWidth"
            >
              <el-form-item label="课数时长：">
                <el-input-number
                  size="small"
                  :min="30"
                  :max="600"
                  :step="30"
                  :disabled="readonly"
                  v-model="dataModel.Minutes"
                  placeholder="请输入课数时长"
                  class="input-width"
                >
                </el-input-number>
              </el-form-item>
            </el-col>

            <el-col
              :span="colWidth"
            >
              <el-form-item label="所属校区：">
                <el-select
                :disabled="readonly"
                  v-model="dataModel.CampusList"
                  multiple
                  placeholder="请选择校区"
                  size="small"
                >
                  <el-option
                    v-for="item in campusList"
                    :key="item.Id"
                    :label="item.Name"
                    :value="item.Id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-button
                v-if="!readonly"
                size="medium"
                type="text"
                icon="el-icon-delete"
                class="delete-button"
                @click="deleteCourse(dataModel)"
              >删除</el-button>
            </el-col>
          </el-row>
        </div>
        <div v-if="courseType !== GLOBAL.courseType.newStudentGuide">
          <div
            v-for="(subPrice, index) in dataModel.SubTrainingPrice"
            :key="subPrice.Guid"
            :name="subPrice.Guid"
            class="course-price"
          >
            <el-row>
              <el-col :span="6">
                <el-form-item
                  :prop="'SubTrainingPrice.' + index + '.Name'"
                  :rules="[{required: true,message: '课程名称不能为空',trigger: 'blur'}]"
                  label-width="10px"
                >
                  <el-input
                    :disabled="readonly"
                    v-model="subPrice.Name"
                    required
                    placeholder="请输入课程名称"
                    class="cs-trainingprice-name input-width"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col
                :span="3"
                v-if="courseType === GLOBAL.courseType.english"
                class="course-checkbox"
              >
                <el-form-item
                  label=""
                  label-width="10px"
                >
                  <el-checkbox
                    :disabled="readonly"
                    v-model="subPrice.IsHourPrice"
                    class="input-width"
                  >是否小时价
                  </el-checkbox>
                </el-form-item>
              </el-col>
              <el-col :span="colWidth">
                <el-form-item
                  label="课程价："
                  :prop="'SubTrainingPrice.' + index + '.CoursePrice'"
                  :rules="[{required: true,message: '课程价格不能为空',trigger: 'blur'},{
                    validator: validateValue,
                    trigger: 'blur'
                  }]"
                >
                  <el-input
                    :disabled="readonly"
                    v-model="subPrice.CoursePrice"
                    placeholder="请输入价格"
                    class="input-width"
                  >
                    <template slot="append">$</template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col
                :span="colWidth"
                v-if="!subPrice.IsHourPrice"
              >
                <el-form-item
                  label="退换价："
                  :prop="'SubTrainingPrice.' + index + '.RefundPrice'"
                  :rules="[{required: true,message: '课程退换价不能为空',trigger: 'blur'},{
                    validator: validateValue,
                    trigger: 'blur'
                  }]"
                >
                  <el-input
                    :disabled="readonly"
                    v-model="subPrice.RefundPrice"
                    placeholder="请输入价格"
                    class="input-width"
                  >
                    <template slot="append">$</template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col
                :span="colWidth"
                v-if="courseType === GLOBAL.courseType.vocationalTraining"
                class="course-checkbox"
              >
                <el-form-item
                  label=""
                  label-width="10px"
                >
                  <el-checkbox
                    :disabled="readonly"
                    v-model="subPrice.IsFreeVideo"
                    class="input-width"
                  >视频免费
                  </el-checkbox>
                </el-form-item>
              </el-col>
              <el-col :span="2">
                <el-button
                  v-if="!readonly && courseType === GLOBAL.courseType.english"
                  size="medium"
                  type="text"
                  icon="el-icon-delete"
                  class="delete-button"
                  @click="deleteCourse(subPrice, dataModel)"
                >删除</el-button>
              </el-col>
            </el-row>
            <el-row v-if="courseType === GLOBAL.courseType.vocationalTraining">
              <el-col
                :span="colWidth"
              >
                <el-form-item
                  label="每周课数："
                  :prop="'SubTrainingPrice.' + index + '.WeekCount'"
                  :rules="[{required: true,message: '每周课数不能为空',trigger: 'blur'}]"
                >
                  <el-input-number
                    size="small"
                    :min="1"
                    :max="99"
                    :disabled="readonly"
                    v-model="subPrice.WeekCount"
                    placeholder="请输入课数"
                    class="input-width"
                  >
                  </el-input-number>
                </el-form-item>
              </el-col>
              <el-col
                :span="colWidth"
              >
                <el-form-item
                  label="课数时长："
                  :prop="'SubTrainingPrice.' + index + '.Minutes'"
                  :rules="[{required: true,message: '课数时长不能为空',trigger: 'blur'}]"
                >
                  <el-input-number
                    size="small"
                    :min="30"
                    :max="600"
                    :step="30"
                    :disabled="readonly"
                    v-model="subPrice.Minutes"
                    placeholder="请输入课数时长"
                    class="input-width"
                  >
                  </el-input-number>
                </el-form-item>
              </el-col>

              <el-col
                :span="colWidth"
              >
                <el-form-item label="所属校区：">
                  <el-select
                    v-model="subPrice.CampusList"
                    multiple
                    placeholder="请选择校区"
                    size="small"
                  >
                    <el-option
                      v-for="item in campusList"
                      :key="item.Id"
                      :label="item.Name"
                      :value="item.Id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="2">
                <el-button
                  v-if="!readonly"
                  size="medium"
                  type="text"
                  icon="el-icon-delete"
                  class="delete-button"
                  @click="deleteCourse(subPrice, dataModel)"
                >删除</el-button>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-form>
    </div>
    <div v-if="courseType !== GLOBAL.courseType.newStudentGuide && !readonly">
      <el-button
        size="medium"
        type="text"
        icon="el-icon-plus"
        @click="addCourse"
      >添加课程</el-button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.el-row {
  .el-col {
    min-width: 100px;
    .course-checkbox {
      min-width: 100px;
    }
    &:last-of-type {
      min-width: 50px;
    }

    span {
      padding-left: 10px;
      overflow: visible;
      white-space: nowrap;
    }

    .el-form-item {
      margin-bottom: 10px;
    }

    .el-input {
      text-align-last: center;
      width: 100px;

      .el-input__inner {
        padding: 0 10px;
      }

      &.cs-trainingprice-name {
        width: 150px;
      }
    }

    .el-input-number {
      width: 100px;
    }
  }
}

.main-price {
  padding-top: 15px;
  background-color: whitesmoke;
}

.course-price {
  padding-top: 15px;
  background-color: white;
  border-bottom:  1px solid #59c2e6;
}

.delete-button {
  color: red;
  margin-left:15px;
}
</style>

<script>
import { guid } from "../../config/mUtils.js";
import { removeTrainingPrice } from "../../service/globalPriceSetting.service.js";

export default {
  props: {
    readonly: Boolean,
    courseType: Number,
    campusList: Array,
    dataIn: Object,
  },
  data() {
    return {
      dataModel: {
        Id: 0,
        CourseId: 0,
        TrainingCategoryId: 0,
        Name: "",
        Level: 1,
        ParentId: null,
        CoursePrice: 0,
        HourPrice: 0,
        RefundPrice: 0,
        WeekCount: 1,
        Minutes: 180,
        IsHourPrice: false,
        IsFreeVideo: false,
        SubTrainingPrice: [],
        CampusList: []
      },
      optionModel: {
        isReadonly: false
      },
      colWidth: 6,
      colBtnWidth: 3,
      
      rules: {
        RefundPrice: [
          {
            required: true,
            message: "退换价不能为空",
            trigger: "blur"
          },
          {
            validator: this.validateValue,
            trigger: "blur"
          }
        ],
        CoursePrice: [
          {
            required: true,
            message: "课程价格不能为空",
            trigger: "blur"
          },
          {
            validator: this.validateValue,
            trigger: "blur"
          }
        ],
        Name: [
          {
            required: true,
            message: "名称不能为空",
            trigger: "blur"
          }
        ],
        WeekCount: [
          {
            required: true,
            message: "每周课数不能为空",
            trigger: "blur"
          }
        ],
        Minutes: [
          {
            required: true,
            message: "课程时长不能为空",
            trigger: "blur"
          }
        ]
      }
    };
  },
  created() {
    this.init();
  },
  computed: {
    mainCourseName() {
      return this.courseType === this.GLOBAL.courseType.newStudentGuide ? "课程" : "类别";
    }
  },
  methods: {
    init() {
      this.dataModel = $.extend(this.dataModel, this.dataIn);
      /*  if (this.courseType === this.GLOBAL.courseType.english){
          this.colWidth = 6;
      }else{
        this.colWidth = 4;
      } */
    },
    validateValue(rule, value, callback) {
      let message = "";
      let pattern = /^\d+(\.\d+)?$/g;
      let isValid = pattern.test(value);
      if (!!value && !isValid) {
        message = "请输入正确的价格";
      }

      if (Number(value) <= 0) {
        message = "请输入大于0的价格";
      }

      if (!!message) {
        callback(new Error(message));
      } else {
        callback();
      }
    },
    deleteCourse(course, parent) {
      let message = "您确定要删除该课程";
      if (!!course.Name) {
        message += " - " + course.Name;
      }
      this.$confirm(message + "吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          if (!!course.Id) {
            removeTrainingPrice(course.Id, this.courseType).then(result => {
              if (!!result && result.success) {
                this.deleteCourseInList(course, parent);
              } else {
                this.$message.error(result.message);
              }
            });
          } else {
            this.deleteCourseInList(course, parent);
          }
        })
        .catch(() => {});
    },
    deleteCourseInList(course, parent) {
      if (!parent) {
        this.$emit("remove", course);
      } else {
        if (!!course && !!course.Guid) {
          let index = parent.SubTrainingPrice.findIndex(
            i => i.Guid == course.Guid
          );
          parent.SubTrainingPrice.splice(index, 1);
        }
      }
    },
    addCourse() {
      let newCourse = {
        Guid: guid(),
        Id: 0,
        CourseId: 0,
        TrainingCategoryId: this.dataModel.TrainingCategoryId,
        Name: "",
        Level: 2,
        ParentId: null,
        CoursePrice: 0,
        HourPrice: 0,
        RefundPrice: 0,
        WeekCount: 1,
        Minutes: 180,
        IsHourPrice: false,
        IsFreeVideo: false,
        SubTrainingPrice: []
      };
      this.dataModel.SubTrainingPrice.push(newCourse);
    },
    validatePrices() {
      let isValid = true;
      this.$refs.trainingPriceDetailForm.validate(valid => {
        isValid &= valid;
      });
      return isValid;
    },
    getDataModel() {
      return this.dataModel;
    },
  },

  watch: {
    dataIn: function() {
      this.init();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/priceManagement/trainingPriceDetail.vue